// extracted by mini-css-extract-plugin
export default {"base":"frequently-asked-questions-module__base--zop","subtitle":"frequently-asked-questions-module__subtitle--jkX"};